"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {
  return function ({
    addUtilities,
    variants
  }) {
    addUtilities({
      '.appearance-none': {
        appearance: 'none'
      }
    }, variants('appearance'));
  };
}